import React from 'react';
import { Navigate } from 'react-router-dom';

const AGENCY_JWT_KEY = 'agency_jwt';

/**
 * Decodes the agency JWT expiry without verifying signature (verification happens server-side).
 * Returns true if a non-expired token is present.
 */
function hasValidAgencyToken() {
  const token = localStorage.getItem(AGENCY_JWT_KEY);
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem(AGENCY_JWT_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

const AgencyRoute = ({ children }) => {
  if (!hasValidAgencyToken()) return <Navigate to="/agency/login" replace />;
  return children;
};

export default AgencyRoute;
